export default __webpack_public_path__ + "static/media/EcllipseRightBottom.d062b2e5.svg";